import { useContext, useEffect } from "react";
import { AuthContext, type IAuthContext } from "react-oauth2-code-pkce";
import { storeAuthToken } from "./authStorage";

export default function TokenCookieSync(): null {
  const { token, loginInProgress } = useContext<IAuthContext>(AuthContext);

  useEffect(() => {
    // only run in the browser
    if (typeof document === "undefined") return;

    if (!loginInProgress && token) {
      storeAuthToken(token);
    }
  }, [token, loginInProgress]);

  return null;
}
